module.exports = __webpack_public_path__ + "img/me.985268c4.jpeg";